import { INewsForgeTranslationContent } from '../../views/Pages/NewsForge/models/news-forge.models';

export const NEWS_FORGE_CONTENT_UPDATE = '[ACTION] NEWS_FORGE_CONTENT_UPDATE';

export function updateNewsForgeContent(newsForgeContent: INewsForgeTranslationContent) {
	return {
		type: NEWS_FORGE_CONTENT_UPDATE,
		payload: { newsForgeContent: newsForgeContent },
	};
}
